import {isNotNil} from 'ramda';

import {GetWatermarkDetailResponseBody} from '@dms/api/sales';

import {VehicleSelectionMode} from '../../../types/VehicleSelectionMode';
import {WatermarkFormType} from '../types/WatermarkFormType';

export const getDefaultValue = (data?: GetWatermarkDetailResponseBody): WatermarkFormType => ({
  name: data?.name ?? '',
  size: data?.size ?? 100,
  position: data?.position ?? 'center_center',
  fitToImage: data?.fitToImage ?? false,
  usageType: data?.usageType ?? 'ALL_PHOTOS',
  composition: data?.composition ?? null,
  fileId:
    data?.fileId && data?.imageUri
      ? {
          id: data.fileId,
          url: data.imageUri,
        }
      : undefined,
  autoAssign: data?.autoAssign ?? false,
  vehicleSelectionMode: isNotNil(data?.vehicleSelection)
    ? VehicleSelectionMode.BY_CONDITIONS
    : VehicleSelectionMode.ALL_VEHICLES,
  filter: data?.vehicleSelection ?? {},
});
